import React, { useEffect, useRef, forwardRef, useImperativeHandle } from 'react';
import './RichEditor.css';

// Bağımlılık gerektirmeyen basit zengin metin editörü (e-posta gövdesi için).
// Çıktı sunucuda temizlenip e-posta şablonuna yerleştirilir.
const TOOLS = [
  { command: 'bold', label: 'B', title: 'Kalın', style: { fontWeight: 700 } },
  { command: 'italic', label: 'I', title: 'İtalik', style: { fontStyle: 'italic' } },
  { command: 'underline', label: 'U', title: 'Altı çizili', style: { textDecoration: 'underline' } },
  { command: 'formatBlock', value: 'h2', label: 'Başlık', title: 'Başlık' },
  { command: 'formatBlock', value: 'p', label: 'Paragraf', title: 'Normal metin' },
  { command: 'insertUnorderedList', label: '• Liste', title: 'Madde işaretli liste' },
  { command: 'insertOrderedList', label: '1. Liste', title: 'Numaralı liste' },
  { command: 'createLink', label: 'Bağlantı', title: 'Bağlantı ekle' },
  { command: 'removeFormat', label: 'Temizle', title: 'Biçimlendirmeyi kaldır' }
];

const RichEditor = forwardRef(function RichEditor({ value, onChange, placeholder }, ref) {
  const editorRef = useRef(null);

  // Dışarıdan gelen değer değişince (ör. kampanya düzenleme) içeriği güncelle;
  // yazarken imlecin kaçmaması için aynıysa dokunma
  useEffect(() => {
    if (editorRef.current && editorRef.current.innerHTML !== value) {
      editorRef.current.innerHTML = value || '';
    }
  }, [value]);

  // Enter'a basınca <div> yerine <p> oluşsun (e-postada paragraf boşlukları için)
  useEffect(() => {
    document.execCommand('defaultParagraphSeparator', false, 'p');
  }, []);

  const emit = () => onChange(editorRef.current.innerHTML);

  const run = (tool) => {
    editorRef.current.focus();
    if (tool.command === 'createLink') {
      const url = window.prompt('Bağlantı adresi (https://...)');
      if (!url) return;
      document.execCommand('createLink', false, /^https?:\/\//i.test(url) ? url : `https://${url}`);
    } else {
      document.execCommand(tool.command, false, tool.value || null);
    }
    emit();
  };

  useImperativeHandle(ref, () => ({
    // İmlecin olduğu yere metin ekle (değişkenler için)
    insertText(text) {
      editorRef.current.focus();
      document.execCommand('insertText', false, text);
      emit();
    }
  }));

  // Word/web'den yapıştırırken stilleri taşıma, düz metin yapıştır
  const handlePaste = (e) => {
    e.preventDefault();
    const text = e.clipboardData.getData('text/plain');
    document.execCommand('insertText', false, text);
  };

  return (
    <div className="rich-editor">
      <div className="rich-editor-toolbar">
        {TOOLS.map((tool) => (
          <button
            key={tool.label}
            type="button"
            title={tool.title}
            style={tool.style}
            onMouseDown={(e) => e.preventDefault()}
            onClick={() => run(tool)}
          >
            {tool.label}
          </button>
        ))}
      </div>
      <div
        ref={editorRef}
        className="rich-editor-content"
        contentEditable
        suppressContentEditableWarning
        data-placeholder={placeholder}
        onInput={emit}
        onBlur={emit}
        onPaste={handlePaste}
      />
    </div>
  );
});

export default RichEditor;
